import React from "react";

import {
  getItemBillRows,
  normalizeOrderItem,
} from "@/components/pos/orderCartUtils.js";

const formatCurrency = (value) => `Rs ${Number(value || 0).toFixed(2)}`;

export default function PosBillItemBreakdown({
  item,
  className = "",
  compact = false,
}) {
  const normalized = normalizeOrderItem(item);
  const rows = getItemBillRows(normalized);

  if (rows.length === 0) return null;

  return (
    <div
      className={`mt-2 overflow-hidden rounded-lg border bg-muted/30 ${className}`}
    >
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b bg-muted/40 text-left text-xs uppercase tracking-wide text-muted-foreground">
            <th className="px-3 py-2 font-medium">Item</th>
            <th className="px-3 py-2 text-center font-medium">Qty</th>
            <th className="px-3 py-2 text-right font-medium">Unit price</th>
            <th className="px-3 py-2 text-right font-medium">Total</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.key} className="border-b last:border-b-0">
              <td className={`px-3 ${compact ? "py-1.5" : "py-2"}`}>
                <div className="font-medium text-foreground">{row.label}</div>
                <div className="text-xs text-muted-foreground">
                  {row.sublabel}
                </div>
              </td>
              <td
                className={`px-3 text-center tabular-nums font-semibold ${
                  compact ? "py-1.5" : "py-2"
                }`}
              >
                {row.quantity}
              </td>
              <td
                className={`px-3 text-right tabular-nums ${
                  compact ? "py-1.5" : "py-2"
                }`}
              >
                {formatCurrency(row.price)}
              </td>
              <td
                className={`px-3 text-right tabular-nums font-semibold ${
                  compact ? "py-1.5" : "py-2"
                }`}
              >
                {formatCurrency(row.lineTotal)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
